import { ClientTicketStatus } from '@bustickus/models-client';
import * as bi from 'react-bootstrap-icons';

function getTicketStatusIcon(status: ClientTicketStatus): React.ReactNode {
  if (status === 'active') {
    return <bi.Check />;
  }

  if (status === 'archive') {
    return <bi.Archive />;
  }

  if (status === 'canceled') {
    return <bi.X />;
  }

  if (status === 'payment_waiting') {
    return <bi.Clock />;
  }

  if (status === 'refund') {
    return <bi.Ban />;
  }

  return <bi.XLg />;
}

export default getTicketStatusIcon;
